import React from 'react';

const InitialMessage = ({ selected }) => {
  if (selected) return null;

  return (
    <div className="cart-section initial-message">
      <div className="message">Select items before adding them to the shopping cart.</div>
    </div>
  )
};

export default InitialMessage;
